import React, { useEffect, useRef, useState } from 'react';
import { PROCTORING_TYPE } from "../config/appConfig";
import Cookies from "js-cookie";

const ScreenShareInstruction: React.FC = () => {
  const [isReady, setIsReady] = useState(false);

  const returnTo: string = `/system-compatibility?project=${Cookies.get("test_engine_project")}&proctoring_type=` + PROCTORING_TYPE.LIVE;

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.style.overflow = 'auto';
  }, []);

  useEffect(() => {
    const check = () => {
      if (customElements.get('rpt-not-enabled')) {
        setIsReady(true);
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  }, []);

  useEffect(() => {
    const handler = () => {
      window.location.href = returnTo;
    };
    document?.addEventListener('extensionDetected', handler);
    return () => document?.removeEventListener('extensionDetected', handler);
  }, []);

  if (!isReady) return null;

  return (
    <>
      <rpt-not-enabled
        asset-base-url='/angular-components/angular-app/'
      />
    </>
  );
};

export default ScreenShareInstruction;
